import Tanks from './TanksScreen'

export default Tanks
export { Tanks }
